import { $Q, $Qll } from '../utils/query-selector';

/**
 * @returns Open modal
 */
const chatAction = () => {
  if (!window.GorgiasChat) return;
  return window.GorgiasChat.open();
};

/**
 * On phone action
 * @param {HTMLElement} target - Button on click
 * @returns Redirection to phone action
 */
const phoneAction = (target, e) => {
  blockDefaultActionToDesktop(e);
};

/**
 * On Whatsapp action
 * @param {HTMLElement} target - Button on click
 * @returns Redirection Whatsapp app
 */
const whatsappAction = (target, e) => {
  blockDefaultActionToDesktop(e);
};

/**
 * Block default action to desktop
 * @param {node} target
 * @param {object} e
 */
const blockDefaultActionToDesktop = (target, e) => {
  const mediaQuery = window.matchMedia('(max-width: 650px)');

  if (!mediaQuery.matches) {
    e.preventDefault();
  }
};

const contactActions = {
  phoneAction,
  chatAction,
  whatsappAction,
};

const contactSuccess = () => {
  const url = document.URL;
  const message = $Q('#contact-error-index');

  $Q('#contact_form #request-type') &&
    $Q('#contact_form #request-type').addEventListener('mousedown', (e) => {
      e.target.classList.add('request-type--clicked');
    });

  $Q('#contact_form #phone') &&
    $Q('#contact_form #phone').addEventListener('keypress', (evt) => {
      if (
        (evt.which !== 8 &&
          evt.which !== 0 &&
          evt.which !== 45 &&
          evt.which < 48) ||
        evt.which > 57
      ) {
        evt.preventDefault();
      }
    });

  if (url.includes('contact_posted=true')) {
    message.classList.remove('hidden');
  }
};

/**
 * On load any page, add events to contact buttons
 */
window.addEventListener('load', () => {
  $Qll('.contact-action-js').forEach((button) => {
    console.log('contactActions');

    button.addEventListener('click', (e) => {
      const {
        dataset: { action, link },
      } = button;
      const evt = `${action}Action`;

      if (contactActions[evt]) {
        return contactActions[evt](button, e);
      }

      if (!link || link === '') return;
      return window.open(link);
    });
  });

  contactSuccess();
});

/**
 * On load event submit: Add preferred countries to phone input on contact form
 */
window.addEventListener('load', async () => {
  const contactezNousTelInput = $Q(
    '#contactform-js .form__textfield-notlabel.coutry-custom input'
  );
  if (!contactezNousTelInput) return;

  window.intlTelInput(contactezNousTelInput, {
    preferredCountries: ['FR', 'GB', 'DE', 'IT'],
  });
});
